// Each area's messages live in their own file so screens can be translated independently.
import * as accountingPages from './accountingPages.js';
import * as mobileScreens from './mobileScreens.js';
import * as publicPages from './publicPages.js';
import * as purchasePages from './purchasePages.js';
import * as reportPages from './reportPages.js';
import * as salesPages from './salesPages.js';
import * as settingsPages from './settingsPages.js';
import * as taxPages from './taxPages.js';

export const areasEn = {
  ...accountingPages.en,
  ...mobileScreens.en,
  ...publicPages.en,
  ...purchasePages.en,
  ...reportPages.en,
  ...salesPages.en,
  ...settingsPages.en,
  ...taxPages.en,
};

export const areasAr = {
  ...accountingPages.ar,
  ...mobileScreens.ar,
  ...publicPages.ar,
  ...purchasePages.ar,
  ...reportPages.ar,
  ...salesPages.ar,
  ...settingsPages.ar,
  ...taxPages.ar,
};
